import { useState } from "react";
import { Button, Modal } from "@heroui/react";
import { Icon } from "@iconify/react";

import { useRemoveFromBlackList } from "@/features/black-list/use-black-list.ts";

export function RemoveBlackListModal({
  id,
  phone,
}: {
  id: number;
  phone: string;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const { mutateAsync, isPending } = useRemoveFromBlackList();

  const onRemove = () => {
    mutateAsync({ id }).then(() => setIsOpen(false));
  };

  return (
    <div>
      <Button isIconOnly variant="danger-soft" onPress={() => setIsOpen(true)}>
        <Icon className="size-6" icon="solar:trash-bin-minimalistic-bold" />
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Heading>Подтверждение</Modal.Heading>
              </Modal.Header>
              <Modal.Body>
                Разблокировать {phone}? На номер снова будут уходить SMS.
              </Modal.Body>
              <Modal.Footer>
                <Button variant="ghost" onPress={() => setIsOpen(false)}>
                  Нет, назад
                </Button>

                <Button
                  isPending={isPending}
                  variant="danger"
                  onPress={onRemove}
                >
                  Да, разблокировать
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
